import axios from "axios";
import MetaTags from 'react-meta-tags';
import React, { useState, useEffect } from "react"
import $ from 'jquery';

//Bootstrap and jQuery libraries
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import authHeader from "helpers/authHeader";
import { useHistory } from "react-router-dom";
import Nomination from "../../pages/JSBForms/Nomination"
import TechnoProducts from "../../pages/JSBForms/TechnoProducts"
import FD from "../../pages/JSBForms/FD"
import RD from "../../pages/JSBForms/RD"

import {
    Form,
    Card,
    CardBody,
    Col,
    Container,
    FormGroup,
    Input,
    Row,
    Button,
    FormFeedback,
    Collapse,
    Table,
    Modal
} from "reactstrap"

import classnames from "classnames";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//redux
import { useSelector, useDispatch } from "react-redux";

//GetAll AccountType
import { getAccountType } from "../../store/actions";

//GetAll EntityType
import { getEntityType } from "../../store/actions";

//GetAll Location
import { getLocation } from "../../store/actions";

import { getAPIUrl, branchUrl, createNewAccountUrl, getCustomerAccountHolderList, deleteCustomerAccountHolder, addCustomerAccountHolder, updateAccountOperationUrl, getAccountOperationsDetailsUrl, submitAccountUrl } from "../../helpers/fakebackend_helper";

// GetByLocationId Branch
import { getBranch } from "../../store/actions";

const CreateNewAccount = () => {

    var registrationId = "";

    //=============Define State====================
    const dispatch = useDispatch();
    const [branch, setBranch] = useState([]);
    const [deleteIndex, setDeleteIndex] = useState("");
    const [deleteHolderId, setDeleteHolderId] = useState("");

    //GetAll AccountType
    const { accountTypeData } = useSelector(state => ({
        accountTypeData: state.Registration.accountTypeData,
    }));

    //GetAll EntityType
    const { entityTypeData } = useSelector(state => ({
        entityTypeData: state.Registration.entityTypeData,
    }));

    //GetAll Location
    const { locationData } = useSelector(state => ({
        locationData: state.Registration.locationData,
    }));

    function BindBranch(value) {
        const LocationId = value.toString();
        const branchModel = {
            LocationId: LocationId
        };
        axios.post(branchUrl(), branchModel, { headers: authHeader() }).then((response) => {
            setBranch(response.data)
        }, (error) => {
            console.log(error.response);
        });
    }

    function onChangeLocation(value) {
        const LocationId = value.target.value;
        const branchModel = {
            LocationId: LocationId
        };
        axios.post(branchUrl(), branchModel, { headers: authHeader() }).then((response) => {
            setBranch(response.data)
        }, (error) => {
            console.log(error.response);
        });
    }

    const [statusDetails, setStatusDetails] = useState([]);
    const [modal_backdrop, setmodal_backdrop] = useState(false);

    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);
    const [isPreloader, setPreloader] = useState(false);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    // Is this a LAN environment?
    const isLANEnv = window.location.hostname.includes(process.env.REACT_APP_LAN_URL);

    var authCustomerObject = JSON.parse(localStorage.getItem('authCustomer'));
    registrationId = localStorage.getItem('registrationId');

    const objAccountData = {
        Mobile: authCustomerObject.mobileNo,
        Email: '',
        AccountTypeId: '',
        EntityTypeId: '',
        LocationId: '',
        BranchId: '',
        NoOfHolders: ''
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function FillApplicantDetails(holderSrNo, registrationHoldersId) {
        if (holderSrNo == "1") {
            localStorage.setItem('registrationHoldersId', registrationHoldersId);
            history.push('/FirstHolder', {
                accountType: validation.values.accounttype,
            })
        }
        else {
            localStorage.setItem('registrationHoldersId', registrationHoldersId);
            history.push('/OtherHolder', {
                accountType: validation.values.accounttype,
            })
        }
    }

    function SaveNewAccount() {

        objAccountData.AccountTypeId = $('#ddlaccounttype').val();
        objAccountData.EntityTypeId = $('#ddlentitytype').val();
        objAccountData.LocationId = $('#ddllocation').val();
        objAccountData.BranchId = $('#ddlbranch').val();
        objAccountData.NoOfHolders = $('#txtNoOfHolders').val();

        axios.post(createNewAccountUrl(), objAccountData, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    localStorage.setItem('registrationId', res.data.registrationId.toString());
                    registrationId = localStorage.getItem('registrationId');
                    GetCustomerAccountHolderList(res.data.registrationId.toString());
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                }
            })
    }

    function SubmitAccount() {
        const createAccountModel = {
            RegistrationId: registrationId,
            branchUserName: isLANEnv ? authCustomerObject?.userName : null,
        }

        try {
            setPreloader(true);

            axios.post(submitAccountUrl(), createAccountModel, { headers: authHeader() })
                .then(res => {
                    if (res.data.responseCode == "OK") {
                        var fileName = res.data.fileName;
                        DownloadRegistrationPDF(fileName);
                        setPreloader(false);
                        localStorage.setItem("ReferenceNo", res.data.referenceNo);
                        history.push("/success");
                    }
                    else {
                        ErrorMessage(res.data.responseMessage);
                        setPreloader(false);
                    }
                }).catch(err => {
                    console.log(err);
                    setPreloader(false);
                });
        }
        catch (error) {
            console.log(error);
        }
    }

    function DownloadRegistrationPDF(fileName) {
        //Live application url
        //var url = "JSBOnlineAccountAPI/RegistrationPrintPDF/" + fileName;

        //Development url
        /*var url = getAPIUrl() + "/RegistrationPrintPDF/" + fileName;*/
        var url = getAPIUrl() + "/RegistrationPrintPDF/" + localStorage.getItem("registrationId") + ".pdf";

        axios({
            url: url, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: authHeader()
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        });

        //var a = $("<a target='_blank' rel='noreferrer'/>");
        //a.attr("download", fileName);
        //a.attr("href", url);
        //$("body").append(a);
        //a[0].click();
        //$("body").remove(a);
    };

    function GetCustomerAccountHolderList(Id) {

        const customerDetailModel = {
            RegistrationId: Id
        };

        setPreloader(true);
        axios.post(getCustomerAccountHolderList(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                if (response.data.length > 0) {
                    BindBranch(response.data[0].locationId);
                }
                debugger;
                setStatusDetails(response.data);
                DisableAccountOperations();
                setPreloader(false);
            }, (error) => {
                console.log(error.response);
                setPreloader(false);
            })
    }

    useEffect(() => {
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }
    }, [isPreloader]);

    useEffect(() => {
        localStorage.removeItem('registrationHoldersId');
        dispatch(getAccountType());
        dispatch(getEntityType());
        dispatch(getLocation());

        GetCustomerAccountHolderList(registrationId);
        GetCustomerAccountOperationsDetails();
    }, [dispatch]);

    const objAccountOperationData = {
        RegistrationId: '',
        AccountOperations: ''
    }

    function GetCustomerAccountOperationsDetails() {
        const customerDetailModel = {
            RegistrationId: registrationId
        };

        axios.post(getAccountOperationsDetailsUrl(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                BindAccountOperation(response.data);
                DisableAccountOperations();
            }, (error) => {
                console.log(error.response);
            })
    }

    function DisableAccountOperations() {
        if (parseInt($('#txtNoOfHolders').val()) == 1) {
            $("#rbeither").prop("disabled", true);
            $("#rbformer").prop("disabled", true);
            $("#rbanyone").prop("disabled", true);
            $("#rbjointly").prop("disabled", true);
            $('#rbself').prop('checked', true);
        }
        else {
            $("#rbeither").prop("disabled", false);
            $("#rbformer").prop("disabled", false);
            $("#rbanyone").prop("disabled", false);
            $("#rbjointly").prop("disabled", false);
        }
    }

    function BindAccountOperation(data) {
        if (data.length > 0) {
            if (data[0].accountOperations == "Self") {
                $("#rbself").prop("checked", true);
            }
            else if (data[0].accountOperations == "Either or survivor") {
                $("#rbeither").prop("checked", true);
            }
            else if (data[0].accountOperations == "Former or survivor") {
                $("#rbformer").prop("checked", true);
            }
            else if (data[0].accountOperations == "Anyone or survivor") {
                $("#rbanyone").prop("checked", true);
            }
            else if (data[0].accountOperations == "Jointly by all") {
                $("#rbjointly").prop("checked", true);
            }
        }
    }

    function SaveAccountOperations() {

        var AccountOperations = "";
        if ($("#rbself").prop("checked")) {
            AccountOperations = "Self";
        }
        else if ($("#rbeither").prop("checked")) {
            AccountOperations = "Either or survivor";
        }
        else if ($("#rbformer").prop("checked")) {
            AccountOperations = "Former or survivor";
        }
        else if ($("#rbanyone").prop("checked")) {
            AccountOperations = "Anyone or survivor";
        }
        else if ($("#rbjointly").prop("checked")) {
            AccountOperations = "Jointly by all";
        }

        objAccountOperationData.AccountOperations = AccountOperations;
        objAccountOperationData.RegistrationId = registrationId;

        axios.post(updateAccountOperationUrl(), objAccountOperationData, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    SuccessMessage(res.data.responseMessage);
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                }
            })
    }

    // Form validation
    const validation = useFormik({

        enableReinitialize: true,

        initialValues: {
            accounttype: statusDetails.length == 0 ? '' : statusDetails[0].accountTypeId,
            entitytype: '1',
            location: statusDetails.length == 0 ? '' : statusDetails[0].locationId,
            branch: statusDetails.length == 0 ? '' : statusDetails[0].branchId,
            noofholders: statusDetails.length == 0 ? 1 : statusDetails.length,
        },
        validationSchema: Yup.object({
            accounttype: Yup.string().required("Form Type required"),
            entitytype: Yup.string().required("Entity Type required"),
            location: Yup.string().required("Location required"),
            branch: Yup.string().required("Branch required"),
        }),

        onSubmit: (values) => {
            //console.log("values", values);
        }
    });

    const [col1, setcol1] = useState(true);
    const [col2, setcol2] = useState(false);
    const [col3, setcol3] = useState(false);
    const [col4, setcol4] = useState(false);
    const [col5, setcol5] = useState(false);

    const t_col1 = () => {
        setcol1(!col1);
        setcol2(false);
        setcol3(false);
        setcol4(false);
        setcol5(false);
    };

    const t_col2 = () => {
        setcol2(!col2);
        setcol1(false);
        setcol3(false);
        setcol4(false);
        setcol5(false);
    };

    const t_col3 = () => {
        setcol3(!col3);
        setcol1(false);
        setcol2(false);
        setcol4(false);
        setcol5(false);
    };

    const t_col4 = () => {
        setcol4(!col4);
        setcol1(false);
        setcol2(false);
        setcol3(false);
        setcol5(false);
    };

    const t_col5 = () => {
        setcol5(!col5);
        setcol1(false);
        setcol2(false);
        setcol3(false);
        setcol4(false);
    };

    const formBackground = {
        borderRadius: 8,
        flex: 1,

        padding: "15px"
    }

    const label = {
        color: "black"
    }

    const formMandatory = {
        color: "red",
        fontWeight: "bold"
    }
    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }
    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    const formSubmitButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "large",
        borderRadius: "0.50rem"
    }

    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px",
        width: "99%"
    }

    const history = useHistory();


    function CheckIsValid(controlValues) {
        var x = Object.keys(controlValues[0])
        var isCheckIfUndefined = x.map(p => {
            if (controlValues[0][p] === "" || controlValues[0][p] === undefined) {

                return true
            }
            else
                return false
        })

        var checkResponse = isCheckIfUndefined.includes(true)
        return checkResponse
    }

    function deleteAccountHolderRows(index, Id) {
        debugger;
        const rows = [...statusDetails];
        rows.splice(index, 1);
        setStatusDetails(rows);

        const deleteStatusModel = {
            RegistrationId: localStorage.getItem('registrationId'),
            RegistrationHolderId: Id.toString()
        };

        axios.post(deleteCustomerAccountHolder(), deleteStatusModel, { headers: authHeader() }).then((response) => {
            SuccessMessage(response.data.responseMessage);
            setmodal_backdrop(false);
            DisableAccountOperations();
        }, (error) => {
            ErrorMessage(error.response);
        });
    }

    function addAccountHolderRows() {

        const createAccountHolderModel = {
            RegistrationId: registrationId
        };

        axios.post(addCustomerAccountHolder(), createAccountHolderModel, { headers: authHeader() }).then((response) => {
            GetCustomerAccountHolderList(registrationId);

        }, (error) => {
            ErrorMessage(error.response);
        });
    }

    const isCustomerProfileForm = validation.values.accounttype === 5 ? true : false;

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <MetaTags>
                <title>JSB-Create New Account</title>
            </MetaTags>
            <Container fluid={true} style={{ overflow: "hidden" }}>
                <Row>
                    <Col lg="12">
                        <div className="table-responsive">
                            <Row>
                                <Col lg="12">
                                    <Form onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}>
                                        <Card>
                                            <CardBody style={cardBackground}>
                                                <Row>
                                                    <Col lg="8">
                                                        <FormGroup className="mb-3" style={{ marginTop: "-15px" }}>
                                                            <label style={{ fontSize: "17px", color: "#941116", fontWeight: "bold" }}>Primary details</label>
                                                        </FormGroup>
                                                    </Col>
                                                    {isLANEnv && (
                                                        <Col lg="4" className="text-end">
                                                            <FormGroup className="mb-3" style={{ marginTop: "-15px" }}>
                                                                <label style={{ fontSize: "17px", color: "#941116", fontWeight: "bold" }}>Branch User Name - {authCustomerObject?.userName}</label>
                                                            </FormGroup>
                                                        </Col>
                                                    )}
                                                </Row>
                                                <Row>
                                                    <Col lg="2">
                                                        <FormGroup className="mb-3">
                                                            <label style={label}>Form Type</label><span style={formMandatory}>*</span>
                                                            <Input type="select"
                                                                className="form-select"
                                                                name="accounttype"
                                                                id="ddlaccounttype"
                                                                onChange={validation.handleChange}
                                                                value={validation.values.accounttype || ""}
                                                                invalid={
                                                                    validation.errors &&
                                                                        validation.errors.accounttype &&
                                                                        (validation.touched &&
                                                                            validation.touched.accounttype) ? true : false
                                                                }
                                                                disabled={statusDetails.length > 0}
                                                            >
                                                                <option value="">Form Type</option>
                                                                {
                                                                    accountTypeData.map((value, key) => (
                                                                        <option key={value.id} value={value.id}>
                                                                            {value.accountTypeName}
                                                                        </option>
                                                                    ))
                                                                }

                                                            </Input>
                                                            {
                                                                validation.errors &&
                                                                    validation.errors.accounttype &&
                                                                    (validation.touched &&
                                                                        validation.touched.accounttype) ? (
                                                                    <FormFeedback type="invalid">{validation.errors.accounttype}</FormFeedback>
                                                                ) : null}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="2">
                                                        <FormGroup className="mb-3">
                                                            <label style={label}>Entity Type</label><span style={formMandatory}>*</span>
                                                            <Input type="select"
                                                                className="form-select"
                                                                name="entitytype"
                                                                id="ddlentitytype"
                                                                onChange={validation.handleChange}
                                                                value={validation.values.entitytype || ""}
                                                                invalid={
                                                                    validation.errors &&
                                                                        validation.errors.entitytype &&
                                                                        (validation.touched &&
                                                                            validation.touched.entitytype) ? true : false
                                                                }
                                                                disabled
                                                            >
                                                                <option value="">Entity Type</option>
                                                                {
                                                                    entityTypeData.map((value, key) => (
                                                                        <option key={value.id} value={value.id}>
                                                                            {value.entityTypeName}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </Input>
                                                            {
                                                                validation.errors &&
                                                                    validation.errors.entitytype &&
                                                                    (validation.touched &&
                                                                        validation.touched.entitytype) ? (
                                                                    <FormFeedback type="invalid">{validation.errors.entitytype}</FormFeedback>
                                                                ) : null}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="3">
                                                        <FormGroup className="mb-3">
                                                            <label style={label}>Location</label><span style={formMandatory}>*</span>
                                                            <Input type="select"
                                                                className="form-select"
                                                                name="location"
                                                                id="ddllocation"
                                                                onChange={e => { validation.handleChange(e); onChangeLocation(e) }}
                                                                value={validation.values.location || ""}
                                                                invalid={
                                                                    validation.errors &&
                                                                        validation.errors.location &&
                                                                        (validation.touched &&
                                                                            validation.touched.location) ? true : false
                                                                }
                                                                disabled={statusDetails.length > 0}
                                                            >
                                                                <option value="">Location</option>
                                                                {
                                                                    locationData.map((value, key) => (
                                                                        <option key={value.id} value={value.id}>
                                                                            {value.locationName}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </Input>
                                                            {
                                                                validation.errors &&
                                                                    validation.errors.location &&
                                                                    (validation.touched &&
                                                                        validation.touched.location) ? (
                                                                    <FormFeedback type="invalid">{validation.errors.location}</FormFeedback>
                                                                ) : null}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="3">
                                                        <FormGroup className="mb-3">
                                                            <label style={label}>Branch</label><span style={formMandatory}>*</span>
                                                            <Input type="select"
                                                                className="form-select"
                                                                name="branch"
                                                                id="ddlbranch"
                                                                onChange={validation.handleChange}
                                                                value={validation.values.branch || ""}
                                                                invalid={
                                                                    validation.errors &&
                                                                        validation.errors.branch &&
                                                                        (validation.touched &&
                                                                            validation.touched.branch) ? true : false
                                                                }
                                                                disabled={statusDetails.length > 0}
                                                            >
                                                                <option value="">Branch</option>
                                                                {
                                                                    branch.map((value, key) => (
                                                                        <option key={value.id} value={value.id}>
                                                                            {value.branchName}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </Input>
                                                            {
                                                                validation.errors &&
                                                                    validation.errors.branch &&
                                                                    (validation.touched &&
                                                                        validation.touched.branch) ? (
                                                                    <FormFeedback type="invalid">{validation.errors.branch}</FormFeedback>
                                                                ) : null}
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="2">
                                                        <FormGroup className="mb-3">
                                                            <label style={label}>Number of Holders </label>
                                                            <Input
                                                                name="noofholders"
                                                                placeholder="No of Holders"
                                                                type="text"
                                                                className="form-control"
                                                                id="txtNoOfHolders"
                                                                maxLength="3"
                                                                value={validation.values.noofholders || ""}
                                                                disabled
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col lg="8"></Col>
                                                    <Col lg="4" style={{ textAlign: "right" }}>
                                                        <Button id="btnBack" style={{ marginLeft: "115px", backgroundColor: "rgb(154, 8, 79)", fontSize: "small", borderRadius: "0.5rem" }}
                                                            onClick={() => {
                                                                history.push('/Status');
                                                            }} >
                                                            Back
                                                        </Button>

                                                        <Button id="btnCreate" style={formButton} type="submit" disabled={statusDetails.length > 0}
                                                            onClick={() => {

                                                                let isEmpty = CheckIsValid([{
                                                                    accounttype: validation.values.accounttype,
                                                                    entitytype: validation.values.entitytype,
                                                                    location: validation.values.location,
                                                                    branch: validation.values.branch,
                                                                    noofholders: validation.values.noofholders,
                                                                }])

                                                                if (!isEmpty)
                                                                    SaveNewAccount();
                                                            }} >
                                                            Generate Details
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div style={{ visibility: registrationId == "" || registrationId == undefined ? "collapse" : "visible", marginTop: "-25px" }}>
                                        <Row>
                                            <Col lg="12">
                                                <Card style={cardBackground}>
                                                    <CardBody>
                                                        <Row>
                                                            <Col lg="8">
                                                                <FormGroup className="mb-3" style={{ marginTop: "-15px" }}>
                                                                    <label style={{ fontSize: "17px", color: "#941116", fontWeight: "bold" }}>Account holders status</label>
                                                                </FormGroup>
                                                            </Col>
                                                            {!isCustomerProfileForm && (
                                                                <Col lg="4" style={{ textAlign: "right" }}>
                                                                    <FormGroup className="mb-3" style={{ marginTop: "-15px" }}>
                                                                        <Button id={"btnAdd"} style={{ marginLeft: "55px", backgroundColor: "rgb(154, 8, 79)", fontSize: "small", borderRadius: "0.5rem" }} onClick={() => addAccountHolderRows()}
                                                                        >
                                                                            Add new applicant
                                                                        </Button>
                                                                    </FormGroup>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                        <Row>
                                                            <Table id="dtAccountHolders" className="table table-striped table-bordered table-hover table-condensed bootstrap-datatable datatable dataTable" style={{ textAlign: "center" }}>
                                                                <thead>
                                                                    <tr align="center">
                                                                        <th style={{ width: "10%", border: "1px solid lightgrey" }}>Last Update</th>
                                                                        <th style={{ border: "1px solid lightgrey" }}>Account Holder Name</th>
                                                                        <th style={{ width: "10%", border: "1px solid lightgrey" }}>Status</th>
                                                                        <th style={{ width: "8%", border: "1px solid lightgrey" }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        statusDetails.map((p, index) => (
                                                                            <tr key={index}>
                                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.lastUpdated}</td>
                                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.customerName}</td>
                                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}><label style={{ color: p.status == "Completed" ? "green" : "red", fontWeight: "bold" }}>{p.status}</label></td>
                                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }} className="d-flex flex-wrap gap-1">
                                                                                    <button
                                                                                        type="button" className="btn btn-success"
                                                                                        onClick={() => { FillApplicantDetails(p.holderSrNo, p.registrationHoldersId) }}>
                                                                                        <i className="mdi mdi-pencil"></i>
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger"
                                                                                        onClick={() => { tog_backdrop(), setDeleteIndex(index), setDeleteHolderId(p.registrationHoldersId) }}
                                                                                        data-toggle="modal"
                                                                                        disabled={p.holderSrNo == 1}
                                                                                    >  <i className="mdi mdi-trash-can"></i>
                                                                                    </button>
                                                                                    <Modal
                                                                                        isOpen={modal_backdrop}
                                                                                        toggle={() => {
                                                                                            tog_backdrop();
                                                                                        }}
                                                                                        backdrop={'static'}
                                                                                        id="staticBackdrop"
                                                                                    >
                                                                                        <div className="modal-header">
                                                                                            <h5 className="modal-title" id="staticBackdropLabel">Confirmation</h5>
                                                                                            <button type="button" className="btn-close"
                                                                                                onClick={() => {
                                                                                                    setmodal_backdrop(false);
                                                                                                }} aria-label="Close"></button>
                                                                                        </div>
                                                                                        <div className="modal-body">
                                                                                            <p>Are you sure you want to delete the selected account holder?</p>
                                                                                        </div>
                                                                                        <div className="modal-footer">
                                                                                            <button type="button" className="btn btn-primary" onClick={() => { deleteAccountHolderRows(deleteIndex, deleteHolderId) }}>Yes</button>
                                                                                            <button type="button" className="btn btn-light" onClick={() => {
                                                                                                setmodal_backdrop(false);
                                                                                            }}>No</button>

                                                                                        </div>
                                                                                    </Modal>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <div style={{ visibility: registrationId == "" || registrationId == undefined ? "collapse" : "visible" }}>
                                        <Row style={{ backgroundColor: "white" }}>
                                            <Col lg="12">
                                                <div className="accordion" id="accordion">
                                                    {!isCustomerProfileForm && (
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header" id="headingOne">
                                                                <button
                                                                    className={classnames(
                                                                        "accordion-button",
                                                                        "fw-medium",
                                                                        { collapsed: !col1 }
                                                                    )}
                                                                    type="button"
                                                                    onClick={t_col1}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    Nomination form DA-1
                                                                </button>
                                                            </h2>

                                                            <Collapse isOpen={col1} className="accordion-collapse">
                                                                <div className="accordion-body">
                                                                    <div className="text-muted">
                                                                        <Nomination RegistrationId={registrationId} />
                                                                    </div>
                                                                </div>
                                                            </Collapse>
                                                        </div>
                                                    )}

                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header" id="headingTwo">
                                                            <button
                                                                className={classnames(
                                                                    "accordion-button",
                                                                    "fw-medium",
                                                                    { collapsed: !col2 }
                                                                )}
                                                                type="button"
                                                                onClick={t_col2}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                Techno based products requirement
                                                            </button>
                                                        
                                                            </h2>
                                                        <Collapse isOpen={col2} className="accordion-collapse">
                                                            <div className="accordion-body">
                                                                <TechnoProducts RegistrationId={registrationId} />
                                                            </div>
                                                        </Collapse>
                                                    </div>

                                                    {!isCustomerProfileForm && (
                                                        <div className="accordion-item">
                                                            <h2 className="accordion-header" id="headingThree">
                                                                <button
                                                                    className={classnames(
                                                                        "accordion-button",
                                                                        "fw-medium",
                                                                        { collapsed: !col3 }
                                                                    )}
                                                                    type="button"
                                                                    onClick={t_col3}
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    Instruction for account operations
                                                                </button>
                                                            </h2>
                                                            <Collapse isOpen={col3} className="accordion-collapse">
                                                                <div className="accordion-body">
                                                                    <div className="table-responsive">
                                                                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                                                                            e.preventDefault();
                                                                            return false;
                                                                        }}>
                                                                            <Row>
                                                                                <Col lg="1">
                                                                                    <div className="form-check mb-3">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="exampleRadios"
                                                                                            id="rbself"
                                                                                            value="option1"
                                                                                            defaultChecked
                                                                                        />
                                                                                        <label style={label}
                                                                                            className="form-check-label"
                                                                                            htmlFor="exampleRadios1"
                                                                                        >
                                                                                            Self
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="2">
                                                                                    <div className="form-check mb-3">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="exampleRadios"
                                                                                            id="rbeither"
                                                                                            value="option1"
                                                                                        />
                                                                                        <label style={label}
                                                                                            className="form-check-label"
                                                                                            htmlFor="exampleRadios1"
                                                                                        >
                                                                                            Either or survivor
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="2">
                                                                                    <div className="form-check mb-3">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="exampleRadios"
                                                                                            id="rbformer"
                                                                                            value="option1"
                                                                                        />
                                                                                        <label style={label}
                                                                                            className="form-check-label"
                                                                                            htmlFor="exampleRadios1"
                                                                                        >
                                                                                            Former or survivor
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="2">
                                                                                    <div className="form-check mb-3">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="exampleRadios"
                                                                                            id="rbanyone"
                                                                                            value="option1"
                                                                                        />
                                                                                        <label style={label}
                                                                                            className="form-check-label"
                                                                                            htmlFor="exampleRadios1"
                                                                                        >
                                                                                            Anyone or survivor
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col lg="2">
                                                                                    <div className="form-check mb-3">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="radio"
                                                                                            name="exampleRadios"
                                                                                            id="rbjointly"
                                                                                            value="option1"
                                                                                        />
                                                                                        <label style={label}
                                                                                            className="form-check-label"
                                                                                            htmlFor="exampleRadios1"
                                                                                        >
                                                                                            Jointly by all
                                                                                        </label>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                            <Row>
                                                                                <Col lg="11">
                                                                                </Col>
                                                                                <Col lg="1">
                                                                                    <Button id="firstN" style={formButton} type="submit" onClick={() => {
                                                                                        SaveAccountOperations();
                                                                                    }} >
                                                                                        Save
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        </Form>
                                                                    </div>
                                                                </div>
                                                            </Collapse>
                                                        </div>
                                                    )}

                                                    <div className="accordion-item" style={{ visibility: validation.values.accounttype != "2" ? "hidden" : "visible", display: validation.values.accounttype != "2" ? "none" : "block" }}>
                                                        <h2 className="accordion-header" id="headingFour">
                                                            <button
                                                                className={classnames(
                                                                    "accordion-button",
                                                                    "fw-medium",
                                                                    { collapsed: !col4 }
                                                                )}
                                                                type="button"
                                                                onClick={t_col4}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                FD
                                                            </button>
                                                        </h2>
                                                        <Collapse isOpen={col4} className="accordion-collapse">
                                                            <div className="accordion-body">
                                                                <FD RegistrationId={registrationId} />
                                                            </div>
                                                        </Collapse>
                                                    </div>

                                                    <div className="accordion-item" style={{ visibility: validation.values.accounttype != "3" ? "hidden" : "visible", display: validation.values.accounttype != "3" ? "none" : "block" }}>
                                                        <h2 className="accordion-header" id="headingFive">
                                                            <button
                                                                className={classnames(
                                                                    "accordion-button",
                                                                    "fw-medium",
                                                                    { collapsed: !col5 }
                                                                )}
                                                                type="button"
                                                                onClick={t_col5}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                RD
                                                            </button>
                                                        </h2>
                                                        <Collapse isOpen={col5} className="accordion-collapse">
                                                            <div className="accordion-body">
                                                                <RD RegistrationId={registrationId} />
                                                            </div>
                                                        </Collapse>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row style={{ marginBottom: "35px" }}>
                                <Col lg="12">
                                    <div style={{ visibility: registrationId == "" || registrationId == undefined ? "collapse" : "visible", textAlign: "right" }}>
                                        <Row>
                                            <Col lg="12">
                                                <Button id="btnSubmit" style={formButton} type="submit" onClick={() => {
                                                    SubmitAccount();
                                                }} >
                                                    Submit
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </React.Fragment >
    )
}

export default CreateNewAccount